.compact {
  position: relative;
  min-width: 44px;
  min-height: 44px;
}

.on {
  background-color: var(--tuna-palette-action-selected);
}

/* The note count, over the icon's corner; the button's name already says it */
.badge {
  position: absolute;
  top: 6px;
  right: 4px;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  box-sizing: border-box;
  border-radius: var(--tuna-shape-radius-pill);
  background-color: var(--tuna-palette-primary-main);
  color: var(--tuna-palette-primary-contrastText);
  font-size: var(--tuna-typography-fontSize-2xs);
  font-weight: 700;
  line-height: 16px;
  text-align: center;
}
